import { Modal, Button } from 'react-bootstrap';
import { useState, useId } from "react";
import _ from 'lodash';
import { arrayAny } from '../../utils/arrayUtils';


const NewTaskModal = ({ show, handleCancel, handleSave, selectedProject, templateData }) => {

    const defaultTemplate = { id: 1, templateName: 'Loading...', default: true };
    const [selectedTemplate, setSelectedTemplate] = useState(defaultTemplate);

    const onHide = () => {
        setTaskTitle("");
        setTaskDescription("");
    };

    if (selectedTemplate.id === 1 && templateData && arrayAny(templateData.items)) {
        setSelectedTemplate(current => {
            if (current && current.id === 1) {
                current = templateData.items[0];
                return current;
            }
            return current;
        });
    }

    const [taskTitle, setTaskTitle] = useState("");
    const [taskDescription, setTaskDescription] = useState("");

    const titleId = useId();
    const descriptionId = useId();

    return show ?
        (
            <Modal
                show={show}
                onHide={handleCancel}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Task</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>Task Type</>
                    <div className="mb-3 d-md-flex fw-bold">
                        <div className="dropdown-toggle">
                            <a href="#/" data-bs-toggle="dropdown" className="text-decoration-none text-dark"><i className="far fa-folder fa-fw text-dark text-opacity-50 me-1"></i> {selectedTemplate.templateName} <b className="caret"></b></a>
                            <div className="dropdown-menu dropdown-menu-start">

                                {templateData && arrayAny(templateData.items) ?
                                    Object.entries(templateData.items).map(template => ( // foreach column in data render column
                                        <div key={template[1].id} className="dropdown-item" onClick={e => setSelectedTemplate(template[1])}>
                                            <i className="far fa-folder fa-fw fa-lg text-gray-500 me-1" ></i>{template[1].templateName}
                                        </div>
                                    ))
                                    :
                                    <></>
                                }
                                <a key="addNew" href="#/AddNewTemplate" className="dropdown-item"><i className="far fa-plus fa-fw fa-lg text-gray-500 me-1"></i> ... Add New Template ...</a>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <label htmlFor={titleId}>Task Title:</label>
                    <input className="form-control" id={titleId} placeholder='New Title' value={taskTitle} onInput={e => setTaskTitle(e.target.value)} />

                    <label htmlFor={descriptionId}>Task Description:</label>
                    <textarea className="form-control" rows="3" id={descriptionId} placeholder='New Description' value={taskDescription} onInput={e => setTaskDescription(e.target.value)} />

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { onHide(); handleCancel(); }}>
                        Cancel
                    </Button>
                    {taskTitle && taskTitle.length > 0 ?
                        <Button variant="primary" onClick={() => { handleSave(taskTitle, taskDescription, selectedTemplate, selectedProject); onHide(); }}>
                            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
                            Add
                        </Button> :
                        <>
                            Not Yet Valid
                        </>
                    }
                </Modal.Footer>
            </Modal>


        ) :
        (<></>);
}

export default NewTaskModal;